import React, { useState } from 'react';
import './FloatingWhatsUp.css';
import { FaWhatsapp } from 'react-icons/fa';

const FloatingWhatsUp = ({ registerPanelPosition = 'right' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedOption, setSelectedOption] = useState('');
  const [userType, setUserType] = useState('');
  
  // Position the component
  const positionStyle = registerPanelPosition === 'right' 
    ? { right: '50px', bottom: '150px' }
    : { right: '20px', top: '100px' };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setCurrentStep(2);
  };

  const handleUserTypeSelect = (type) => {
    setUserType(type);
    sendWhatsAppMessage();
    setCurrentStep(1);
    setIsOpen(false);
  };

  const sendWhatsAppMessage = () => {
    const message = `Hello! I'm interested in ${selectedOption}. I'm a ${userType}.`;
    const whatsappUrl = `https://wa.me/916309012237?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const resetForm = () => {
    setCurrentStep(1);
    setSelectedOption('');
    setUserType('');
  };

  return (
    <div className="floating-whatsup-container" style={positionStyle}>
      <button 
        className="whatsup-button"
        onClick={() => {
          setIsOpen(!isOpen);
          if (!isOpen) resetForm();
        }}
      >
        <FaWhatsapp size={42} />
        
        {/* <img src="whatsapp-icon.png" alt="WhatsApp" width="24" height="24" /> */}
      </button>
      {/* <button className="whatsup-button">
  <FaWhatsapp size={24} />
</button> */}
      {isOpen && (
        <div className="whatsup-panel">
          <div className="whatsup-header">
            <h3>{currentStep === 1 ? 'Select Course Interest' : 'Are you a...'}</h3>
            <button 
              className="close-button"
              onClick={() => {
                setIsOpen(false);
                resetForm();
              }}
            >
              ×
            </button>
          </div>
          
          <div className="whatsup-content">
            {currentStep === 1 ? (
              <div className="options-container">
                <button className="option-btn" onClick={() => handleOptionSelect('Admin Course')}>
                  AI Bootcamp 
                </button>
                <button className="option-btn" onClick={() => handleOptionSelect('LWC Course')}>
                  LWC Course
                </button>
                <button className="option-btn" onClick={() => handleOptionSelect('Platform Developer Course')}>
                  Platform Developer Course
                </button>
                <button className="option-btn" onClick={() => handleOptionSelect('MERN Stack Course')}>
                  MERN Stack Course
                </button>
                <button className="option-btn" onClick={() => handleOptionSelect('Other Course')}>
                  Other Course
                </button>

              </div>
            ) : (
              <div className="options-container">
                <button className="option-btn" onClick={() => handleUserTypeSelect('student')}>
                  Student
                </button>
                <button className="option-btn" onClick={() => handleUserTypeSelect('working professional')}>
                  Working Professional
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FloatingWhatsUp;